import {
  GET_ACCOUNT_RECEIPT_LIST,
  GET_PERFORMA_INVOICE_RECEIPT_LIST,
  ACCOUNT_RECEIPT_GENERATE_INVOICE,
  ADD_ACCOUNT_RECEIPT_LIST,
  UPDATE_ACCOUNT_RECEIPT_LIST,
  GET_ACCOUNT_RECEIPT_DETAILS,
  DELETE_ACCOUNT_RECEIPT_LIST,
  GET_RECEIPT_NO_ACTION_TYPE,
  RECEIPT_TAX_INVOICE_ACTION_TYPE,
  RECEIPT_NO_DUE_ACTION_TYPE,
  GET_SEND_MAIL_RECEIPT_DETAILS_ACTION_TYPE,
  SEND_TAX_INVOICE_ACTION_TYPE,
  PREVIEW_RECEIPT_ACTION_TYPE,
} from "../../utils/constants";

const initialState = [];

function accountReceiptReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_ACCOUNT_RECEIPT_LIST:
      return [...state, payload];
    case GET_PERFORMA_INVOICE_RECEIPT_LIST:
      return [...state, payload];
    case ACCOUNT_RECEIPT_GENERATE_INVOICE:
      return [...state, payload];
    case ADD_ACCOUNT_RECEIPT_LIST:
      return [...state, payload];
    case UPDATE_ACCOUNT_RECEIPT_LIST:
      return [...state, payload];
    case GET_ACCOUNT_RECEIPT_DETAILS:
      return [...state, payload];
    case DELETE_ACCOUNT_RECEIPT_LIST:
      return [...state, payload];
    case GET_RECEIPT_NO_ACTION_TYPE:
      return [...state, payload];
    case RECEIPT_NO_DUE_ACTION_TYPE:
      return [...state, payload];
    case RECEIPT_TAX_INVOICE_ACTION_TYPE:
      return [...state, payload];
    case GET_SEND_MAIL_RECEIPT_DETAILS_ACTION_TYPE:
      return [...state, payload];
    case SEND_TAX_INVOICE_ACTION_TYPE:
      return [...state, payload];
    case PREVIEW_RECEIPT_ACTION_TYPE:
      return [...state, payload];
    default:
      return state;
  }
}

export default accountReceiptReducer;
